import merge from "deepmerge"
import styled, { css } from "styled-components"
import { IntentPrefetchLink } from "@/components/Link"

import { theme as tsrTheme } from "@/design/tsr-ui/components"
import { theme as appTheme } from "@/theme"

const theme = merge(tsrTheme, appTheme)

export const LogoLink = styled(IntentPrefetchLink)`
  ${() => {
    const { spaces } = theme

    return css`
      display: block;
      padding-bottom: ${spaces.small};
      padding-top: 1.5rem;
    `
  }}
`

export const H2 = styled.h2`
  ${() => {
    const { fonts } = theme

    return css`
      margin: 0;
      font-size: ${fonts.size.heading3};
      text-transform: uppercase;
      font-weight: ${fonts.weight.regular};
      text-align: center;
    `
  }}
`

export const Footer = styled.footer`
  ${() => {
    const { spaces } = theme

    return css`
      display: flex;
      justify-content: space-between;
      margin-top: ${spaces.large};
    `
  }}
`
export const ErrorCard = styled.section`
  ${() => {
    const { borders, colors, spaces } = theme

    return css`
      background-color: ${colors.content.bg};
      border-radius: ${borders.radius.standard};
      padding: ${spaces.large};
      margin-top: 4rem;
    `
  }}
`
export const ErrorBox = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 25rem;
  height: 100%;
`
export const MainNavigation = styled.div`
  ${() => {
    const { spaces } = theme
    return css`
      padding: ${spaces.small};
    `
  }}
`

export const Nav = styled.nav`
  ${() => {
    const { colors } = theme
    return css`
      display: flex;
      background-color: ${colors.content.bg};
      height: 100%;
    `
  }}
`

export const Main = styled.main`
  margin: 0 auto;
  width: 90%;
  max-width: 25rem;
  height: 100%;
  overflow: hidden;
`

export const AuthContainer = styled.div`
  ${() => {
    const { fonts, colors, spaces } = theme

    return css`
      display: grid;
      grid-template-columns: auto 1fr;
      grid-gap: ${spaces.large};

      color: ${colors.fg};
      background-color: ${colors.bg};
      margin: 0;
      min-height: 100vh;
      text-rendering: optimizeSpeed;

      flex-direction: column;
      align-items: center;
      height: -webkit-fill-available;
      -webkit-overflow-scrolling: touch;

      font-family: "Roboto Condensed", Arial, sans-serif;
      font-weight: ${fonts.weight.regular};
      overflow-x: hidden;
    `
  }}
`

export const Body = styled.div`
  ${() => {
    const { colors } = theme

    return css`
      color: ${colors.fg};
      background-color: ${colors.bg};
      margin: 0;
      padding: 0;
      display: block;
      width: 100%;
      height: auto;
      min-height: 100vh;
      font-family: "Roboto Condensed", Arial, sans-serif;
      overflow: hidden;
    `
  }}
`

export const SecondaryButton = styled.button`
  ${() => {
    return css`
      display: inline-flex;
      gap: 0.375rem;
      -moz-box-align: center;
      align-items: center;
      margin: 0;
      height: fit-content;
      font-family: "Roboto Condensed", Arial, sans-serif;
      font-size: 0.875rem;
      line-height: 1;
      font-weight: 700;
      border-radius: 6.25rem;
      padding: 0.25rem 0.75rem;
      cursor: pointer;
      text-decoration: none;
      background-color: rgb(168, 218, 220);
      color: rgb(29, 53, 87);
      border: 1px solid rgb(168, 218, 220);
      &:hover {
        background-color: rgba(168, 218, 220, 0.8);
        border-color: rgba(168, 218, 220, 0.8);
      }
    `
  }}
`
export const Button = styled.button`
  ${() => {
    return css`
      display: inline-flex;
      gap: 0.375rem;
      -moz-box-align: center;
      align-items: center;
      margin: 0;
      height: fit-content;
      font-family: "Roboto Condensed", Arial, sans-serif;
      background-color: transparent;
      font-size: 0.875rem;
      line-height: 1;
      font-weight: 700;
      border-radius: 6.25rem;
      padding: 0.25rem 0.75rem;
      border: 1px transparent;
      &:hover {
        background-color: rgba(29, 53, 87, 0.2);
      }
    `
  }}
`
